import { IconBase, IconComponent } from './BaseIcon';

export const Stars: IconComponent = (props) => (
  <IconBase {...props}>
    <path
      fill="#333"
      d="M15.48 18.48a1.07 1.07 0 0 1-.6-.51l-1.89-3.71-3.64-1.86a1.1 1.1 0 0 1-.58-.96c0-.4.22-.75.56-.94l3.7-1.86 1.87-3.67c.2-.36.56-.58.96-.58.4 0 .76.22.95.57l1.8 3.66 3.72 1.9c.36.2.58.56.58.95 0 .4-.22.76-.56.95l-3.63 1.84-1.95 3.7a1.1 1.1 0 0 1-1.29.51v.01ZM6.87 22.16a.65.65 0 0 1-.36-.3L5.37 19.6l-2.2-1.11a.65.65 0 0 1 0-1.16l2.23-1.12 1.13-2.22a.65.65 0 0 1 1.15 0l1.1 2.22 2.25 1.14c.22.12.35.34.35.58 0 .24-.13.46-.34.58l-2.2 1.12-1.17 2.23a.65.65 0 0 1-.78.32l-.02-.02ZM6.96 7.9a.37.37 0 0 1-.23-.19l-.7-1.39-1.37-.69a.41.41 0 0 1-.21-.36.4.4 0 0 1 .2-.35l1.39-.7.7-1.37a.41.41 0 0 1 .35-.22.4.4 0 0 1 .36.21l.67 1.38 1.4.7c.13.08.21.21.21.36a.4.4 0 0 1-.2.35l-1.36.7-.73 1.37a.4.4 0 0 1-.36.21c-.05 0-.1 0-.13-.02Z"
    />
  </IconBase>
);
